<div
  autosize
  autoFocus
  [ngClass]="{
  'sidebarNav-mini': options.sidenavCollapsed && options.navPos !== 'top',
  'sidebarNav-horizontal': options.horizontal,
  cardBorder: options.cardBorder,
  orange_theme: options.activeTheme == 'orange_theme',
  blue_theme: options.activeTheme == 'blue_theme',
  aqua_theme: options.activeTheme == 'aqua_theme',
  purple_theme: options.activeTheme == 'purple_theme',
  green_theme: options.activeTheme == 'green_theme',
  cyan_theme: options.activeTheme == 'cyan_theme'
  }"
  [dir]="options.dir!"
  >
  <!-- Topbar removed; logo + logout live in sidebar 28/10/2026 DW -->
  <mat-sidenav-container class="mainWrapper sd-shell-no-topbar" style="height: 100vh; width: 100vw; display: block;">
    <!-- ============================================================== -->
    <!-- Vertical Sidebar -->
    <!-- ============================================================== -->
    @if (!options.horizontal) {
      <mat-sidenav
        #leftsidenav
        [mode]="isOver ? 'over' : 'side'"
        [opened]="options.navPos === 'side' && options.sidenavOpened && !isOver"
        (openedChange)="onSidenavOpenedChange($event)"
        (closedStart)="onSidenavClosedStart()"
        class="sidebarNav sd-sidebar-shell"
        style="width: 283px; min-width: 283px; max-width: 283px;"
        >
        <div class="sd-sidebar-inner flex-layout">
          <app-branding></app-branding>
          <ng-scrollbar class="position-relative mini-scroll sd-sidebar-nav-scroll">
            <mat-nav-list class="sidebar-list">
              @for (item of navItems; track item) {
                <app-nav-item
                  [item]="item"
                  (notify)="sidenav.toggle()"
                  >
                </app-nav-item>
              }
            </mat-nav-list>
          </ng-scrollbar>
          <div class="sd-sidebar-footer">
            <!-- Primary green logout 28/10/2026 DW -->
            <button
              id="header-logout-btn"
              type="button"
              (click)="authService.logout()"
              mat-raised-button
              color="primary"
              class="w-100 sd-sidebar-logout-btn"
            >
              Logout
            </button>
          </div>
        </div>
      </mat-sidenav>
    }
    <!-- ============================================================== -->
    <!-- horizontal Sidebar (mobile overlay) -->
    <!-- ============================================================== -->
    @if (resView) {
      <mat-sidenav
        #leftsidenav
        [mode]="'over'"
        [opened]="options.sidenavOpened && !isTablet"
        (openedChange)="onSidenavOpenedChange($event)"
        (closedStart)="onSidenavClosedStart()"
        class="sidebarNav sd-sidebar-shell"
        >
        <div class="sd-sidebar-inner flex-layout">
          <app-branding></app-branding>
          <ng-scrollbar class="position-relative mini-scroll sd-sidebar-nav-scroll">
            <mat-nav-list class="sidebar-list">
              @for (item of navItems; track item) {
                <app-nav-item
                  [item]="item"
                  (notify)="sidenav.toggle()"
                  >
                </app-nav-item>
              }
            </mat-nav-list>
          </ng-scrollbar>
          <div class="sd-sidebar-footer">
            <!-- Primary green logout 28/10/2026 DW -->
            <button
              id="header-logout-btn-mobile"
              type="button"
              (click)="authService.logout()"
              mat-raised-button
              color="primary"
              class="w-100 sd-sidebar-logout-btn"
            >
              Logout
            </button>
          </div>
        </div>
      </mat-sidenav>
    }
    <!-- ============================================================== -->
    <!-- Main Content -->
    <!-- ============================================================== -->
    <mat-sidenav-content class="contentWrapper">
      @if (options.horizontal) {
        <app-horizontal-sidebar
        ></app-horizontal-sidebar>
      }
      <main
        class="pageWrapper"
        [ngClass]="{
        maxWidth: options.boxed
        }"
        >
        <app-breadcrumb></app-breadcrumb>
        <router-outlet></router-outlet>
      </main>
      <!-- App footer removed; credit shown on home only 28/10/2026 DW -->
    </mat-sidenav-content>
    <mat-sidenav
      #customizerRight
      mode="over"
      position="end"
      class="fixed-customizer"
      >
      <app-customizer (optionsChange)="receiveOptions($event)"></app-customizer>
    </mat-sidenav>
  </mat-sidenav-container>
</div>
